import React from 'react'
import { Add } from 'iconsax-react'
import { useTheme } from '@mui/material'

import useStyles from './styles'

const FloatingActionButtonV2 = ({ icon = undefined, onClick = undefined }) => {
  const theme = useTheme()

  const iconEl = icon ?? <Add color='white' size={theme.size.xxxl} />
  const classes = useStyles()

  const handleOnClick = React.useCallback(() => {
    onClick && onClick()
  }, [onClick])

  return (
    <button onClick={handleOnClick} className={classes.button}>
      {iconEl}
    </button>
  )
}

export default FloatingActionButtonV2
